import React from 'react';

import {Link} from "react-router";

import {api} from "./baseFunctions";

import Right from "./Right";
import CoolLoader from "./CoolLoader";
import Panel from "./Panel";
import FormItem from "./FormItem";
import Chart from "./UI/Chart/Chart";
import Modal from "./UI/Modal/Modal";

export default class InboxPage extends React.Component {
  constructor(){
    super();
    this.getData = this.getData.bind(this);
    this.sendInbox = this.sendInbox.bind(this);
    this.typeHandler = this.typeHandler.bind(this);
    this.resetInbox = this.resetInbox.bind(this);
    this.isSaving = false;
    this.overViewTable = false;
    this.state = {
      chartType: "pie",
      currType: 0,
      typeValues: [],
      data: false,
      users: [],
    };
  }
  componentDidMount(){
    this.getData();
  }
  resetInbox()
  {
    this.setState({currType: 0, typeValues: [], chartType: "pie"});
  }
  sendInbox(e){
    e.preventDefault();
    if(this.isSaving)
    {
      console.log("Already saving");
      return false;
    }
    this.isSaving = true;
    var data = {
      users: [...this.refs.users.selectedOptions].map((d,key) => Number(d.value)),
      title: this.refs.title.value,
      message: this.refs.msg.value,
      type: this.state.currType,
      values: this.state.typeValues,
    };
    //let accepted = true;
    let accepted = Object.keys(data).find((d) => {
      if(d === "values")
      {
        if(data.type === 1 && data[d].length === 0)
        {
          return true;
        }
      }else if(data[d].length === 0)
      {
        console.log(d, data[d]);
        return true;
      }
      return false;
    });
    /*Object.keys(data).map((d) => {
      if(d === "values")
      {
        if(data.type === 1 && data[d].length === 0)
        {
          accepted = false;
        }
      }else if(data[d].length === 0)
      {
        accepted = false;
      }
    });*/
    if(typeof accepted !== "undefined")
    {
      this.isSaving = false;
      alert("Alle felter skal udfyldes!");
      return false;
    }

    api("POST", {"type": "sendInbox", data}, (d) => {
      this.isSaving = false;
      if(!d.error)
      {
        alert("Beskeden er blevet afsendt!");
        this.getData();
        this.props.router.push("/inbox");
      }
    }, this.props.auth, 1);
  }
  getData(){
    api("POST", {"type": "getInbox"}, (d) => {
      console.log(d);
      if(!d.error)
      {
        this.setState({data: d.data, users: d.users});
        requestAnimationFrame(() => {
          if(this.overViewTable)
          {
            this.overViewTable.fnDestroy();
          }
          this.overViewTable = window.$("#sheets").DataTable({
            "iDisplayLength": 50,
            "order": [[ 0, "desc" ]],
            "language": {
                "lengthMenu": "Vis _MENU_ pr side",
                "zeroRecords": "Intet fundet",
                "info": "Side _PAGE_ / _PAGES_",
                "infoEmpty": "Intet indhold",
                "search":         "Søg: ",
                 "paginate": {
                    "first":      "Første",
                    "last":       "Sidste",
                    "next":       "Næste",
                    "previous":   "Forrige"
                },
                "infoFiltered": "(filterer fra _MAX_ colonner)"
            }
          });
        });
      }
    }, this.props.auth, 1);
  }
  typeHandler(e, type, target)
  {
    if(type === "keyDown")
    {
      let key = e.key || e.keyCode;
      if(key !== "Enter")
      {
        //console.log("Keycode", key, e);
        return false;
      }
    }
    let val = e.target.value;
    if(val.length === 0)
    {
      return;
    }
    let newTypes = [...this.state.typeValues];
    if(typeof target === "number")
    {
      newTypes[target] = val;
    }else{
      newTypes.push(val);
      console.log("Adding ", val);
    }
    this.setState({typeValues: newTypes});

    this.refs.typeInp.value = "";
    requestAnimationFrame(() => this.refs.typeInp.focus());
    //console.log("Add type", val);
  }
	render(){
    const IS_READING = this.props.route.path.indexOf("/inbox/read/") !== -1;
    const CURR_READ = IS_READING && this.state.data ? this.state.data.find((d) => d.id === this.props.params.id) : false;
    const READ_GROUP = CURR_READ && CURR_READ.groupID !== "0" ? this.state.data.filter((d) => d.groupID === CURR_READ.groupID) : false;
    let grouped = [];
    let chartData = [];
    const CHART_TYPES = ["pie", "bar"];
    const CHART_ICONS = {
        "pie": "fa-pie-chart",
        "bar": "fa-bar-chart",
    };
    let oneUsr;
    if(CURR_READ)
    {
      if(READ_GROUP)
      {
        let count = {};
        READ_GROUP.map((d, key) => {
          let tempResp = d.resp === null ? "Intet svar" : CURR_READ.typeData[Number(d.resp)];
          if(!count[tempResp])
          {
            count[tempResp] = 0;
          }
          count[tempResp]++;
        });
        chartData = count;
      }else{
        let tempResp = CURR_READ.resp === null ? "Intet svar" : CURR_READ.typeData[Number(CURR_READ.resp)];
        chartData[tempResp] = 1;
        oneUsr = this.state.users.find((usr) => usr.id === CURR_READ.to);
      }
    }
		return (
    <Right token={this.props.auth} lang={this.props.lang}>

      {
        IS_READING && CURR_READ ?
        <Panel title="Besked" key={"message" + this.props.params.id}>
          <FormItem name="Titel">
            <input type="text" disabled={true} className="form-control col-md-7 col-xs-12" defaultValue={CURR_READ.title}/>
          </FormItem>
          <FormItem name="Besked">
            <textarea disabled={true} className="form-control col-md-7 col-xs-12">
              {
                CURR_READ.text
              }
            </textarea>
          </FormItem>
          <FormItem name={READ_GROUP ? "Modtagere" : "Modtager"}>
            <table className="table table-striped jambo_table bulk_action">
              <thead>
                <tr>
                  <td>#</td>
                  <td>Modtager</td>
                  <td>Åbnet</td>
                  {
                    CURR_READ.type === "2" ?
                      <td>Underskrift</td>
                    : null
                  }
                </tr>
              </thead>
              <tbody>
                {
                  READ_GROUP ?
                    READ_GROUP.map((d, key) => {
                      const USR = this.state.users.find((usr) => usr.id === d.to);
                      return (<tr key={"name" + key}>
                          <td>{d.to}</td>
                          <td>{USR ? <Link to={"/user/" + USR.id}>{USR.name}</Link> : "Ukendt bruger"}</td>
                          <td><i className={d.opened === "0" ? "fa fa-eye-slash" : "fa fa-eye"} aria-hidden="true"></i></td>
                          {
                            CURR_READ.type === "2" ?
                              <td>
                                {
                                  d.resp === null ?
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                  : 
                                  <div>
                                    <Modal 
                                      title={"Underskrift"}
                                      divStyle={{position: "relative"}}
                                      toggleStyle={{float: "right"}}
                                      toggleButton={() => <i className="fa fa-clone" aria-hidden="true"></i>}
                                      content={() => <div style={{pointerEvent: "none", userSelect: "none"}} onDragStart={() => false} onselectstart={() => false}>
                                        <h1>{CURR_READ.title}</h1>
                                        {CURR_READ.text}<br/>
                                        <img src={"https://safeallday.dk/new/v2/img/uploads/" + CURR_READ.resp} style={{maxHeight: "80px", marginTop: "50px"}}/>
                                      </div>}
                                      customBtn={(contentRefID) => <button type="button" className="btn btn-default" onClick={() => {
                                        let ref = document.getElementById(contentRefID);
                                        if(ref)
                                        {
                                          let w = window.open();
                                          w.document.write(ref.innerHTML);
                                          w.print();
                                          w.close();
                                        }
                                      }}>
                                        <i className="fa fa-print" aria-hidden="true"></i>
                                      </button>}
                                    />
                                    <img src={"https://safeallday.dk/new/v2/img/uploads/" + d.resp} style={{maxHeight: "20px"}}/>
                                  </div>
                                }
                              </td>
                            : null
                          }
                        </tr>);
                    }) :
                  <tr>
                    <td>{CURR_READ.to}</td>
                    <td>{oneUsr ? <Link to={"/user/" + oneUsr.id}>{oneUsr.name}</Link> : "Ukendt bruger"}</td>
                    <td><i className={CURR_READ.opened === "0" ? "fa fa-eye-slash" : "fa fa-eye"} aria-hidden="true"></i></td>
                    {
                      CURR_READ.type === "2" ?
                        <td>
                          {
                            CURR_READ.resp === null ?
                              <i className="fa fa-times" aria-hidden="true"></i>
                            : 
                            <div>
                              <Modal 
                                title={"Underskrift"}
                                divStyle={{position: "relative"}}
                                toggleStyle={{float: "right"}}
                                toggleButton={() => <i className="fa fa-clone" aria-hidden="true"></i>}
                                content={() => <div style={{pointerEvent: "none", userSelect: "none"}} onDragStart={() => false} onselectstart={() => false}>
                                  <h1>{CURR_READ.title}</h1>
                                  {CURR_READ.text}<br/>
                                  <img src={"https://safeallday.dk/new/v2/img/uploads/" + CURR_READ.resp} style={{maxHeight: "80px", marginTop: "50px"}}/>
                                </div>}
                                customBtn={(contentRefID) => <button type="button" className="btn btn-default" onClick={() => {
                                  let ref = document.getElementById(contentRefID);
                                  if(ref)
                                  {
                                    let w = window.open();
                                    w.document.write(ref.innerHTML);
                                    w.print();
                                    w.close();
                                  }
                                }}>
                                  <i className="fa fa-print" aria-hidden="true"></i>
                                </button>}
                              />
                              <img src={"https://safeallday.dk/new/v2/img/uploads/" + CURR_READ.resp} style={{maxHeight: "30px"}}/>
                            </div>
                          }
                        </td>
                      : null
                    }
                  </tr>
                }
              </tbody>
            </table>
          </FormItem>
          {
            CURR_READ.type === "1" ?
              <FormItem name={"Besvarelser"}>
                <div className="btn-group" role="group" aria-label="...">
                  {
                    CHART_TYPES.map((d, key) => 
                      <button className={"btn btn-default" + (d === this.state.chartType ? " active" : "")} onClick={() => this.setState({chartType: d})} key={"chartBtn" + key} type="button">
                        <i className={"fa " + CHART_ICONS[d]} aria-hidden="true"></i>
                      </button>)
                  }
                </div>
                <Chart type={this.state.chartType} data={chartData} style={{maxWidth: "400px"}}/>
              </FormItem>
            : null
          }
        </Panel>
        : null
      }
      {
        this.props.route.path === "/inbox/new" ?
          <Panel title="Ny besked">
              <FormItem name="Titel" must={1}>
                <input type="text" required={true} className="form-control col-md-7 col-xs-12" ref="title" required=""/>
              </FormItem>
              <FormItem name="Modtagere" must={1}>
                <select multiple={true} required={true} className="form-control col-md-7 col-xs-12" ref="users">
                  {
                    this.state.users.map((d, key) => <option key={"user" + key} value={d.id}>[{d.id}] {d.mail}</option>)
                  }
                </select>
              </FormItem>
              <FormItem name="Besked" must={1}>
                <textarea required={true} className="form-control col-md-7 col-xs-12" ref="msg"></textarea>
              </FormItem>
              <FormItem name="Type">
                <select className="form-control col-md-7 col-xs-12" onChange={(v) => this.setState({currType: Number(v.target.value)})}>
                  <option value={0}>Alm. besked</option>
                  <option value={1}>Afstemning</option>
                  <option value={2}>Underskrift</option>
                </select>
              </FormItem>
              {
                this.state.currType === 1 ?
                  <FormItem name="Afstemning">
                    <table className="table table-striped jambo_table bulk_action">
                      <thead>
                        <tr>
                          <td>Valgmulighed</td>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.typeValues.map((d, key) => <tr key={"typeInp" + key}>
                          <td>
                            <input onBlur={(e) => this.typeHandler(e, false, key)} onKeyDown={(e) => this.typeHandler(e, "keyDown", key)} defaultValue={d} className="form-control col-md-7 col-xs-12"/>
                          </td>
                        </tr>)
                        }


                        <input onBlur={this.typeHandler} onKeyDown={(e) => this.typeHandler(e, "keyDown")} ref="typeInp" className="form-control col-md-7 col-xs-12"/>
                      </tbody>
                    </table>
                  </FormItem>
                : null
              }
              <div className="form-group">
                <div className="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                  <button type="submit" className="btn btn-success" onClick={this.sendInbox}>Send</button>
                </div>
              </div>
          </Panel>
        : null
      }
      <Panel title="Udbakke" add="/inbox/new" onAdd={this.resetInbox}>
        <CoolLoader show={!this.state.data} type="table"/>
        {
          this.state.data ?
            <table className="table table-striped jambo_table bulk_action" id="sheets">
              <thead>
                  <tr className="headings">
                      <th className="column-title"># </th>
                      <th className="column-title">Titel </th>
                      <th className="column-title">Til </th>
                      <th className="column-title">Type</th>
                      <th className="column-title"> </th>
                      <th className="column-title"> </th>
                  </tr>
              </thead>
              <tbody>
              {
                this.state.data.map((d, key) => {
                  const IS_GROUP = d.groupID !== "0";
                  if(!IS_GROUP || grouped.indexOf(d.groupID) === -1)
                  {
                    let currUsr = (<i className={"fa fa-users"} aria-hidden="true"></i>);
                    if(IS_GROUP)
                    {
                      grouped.push(d.groupID);
                    }else{
                      let temp = this.state.users.find((usr) => usr.id === d.to);
                      currUsr = temp ? <Link to={"/user/" + temp.id}>{temp.name}</Link> : "Ukendt bruger";
                    }
                    return (<tr key={"msg" + key}>
                      <td>{d.id}</td>
                      <td>{d.title}</td>
                      <td>{currUsr}</td>
                      <td>{d.cat === "1" ? "System" : "Personlig"}</td>
                      <td>
                        {
                          !IS_GROUP ?
                            <i className={d.opened === "0" ? "fa fa-eye-slash" : "fa fa-eye"} aria-hidden="true"></i>
                          : null
                        }
                      </td>
                      <td>
                        <Link to={"/inbox/read/" + d.id} onClick={this.resetInbox}>Vis mere</Link>
                      </td>
                    </tr>);
                  }
                })
              }
              </tbody>
            </table>
          : null
        }
        
      </Panel>
    </Right>);
	}
}



// WEBPACK FOOTER //
// ./src/components/InboxPage.js